import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { ButtonTypeAttributeEnum, ButtonTypeEnum } from '@hrra/ui';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { selectSystemConfigs } from '../../root-store/selectors';
import { AppState } from '../../root-store/state';
import { SystemConfig } from '../../shared/models/system-config-model';
import { IndustryListItem } from 'src/app/shared/models/industry-model';
import { Dictionary } from '@hrra/core';
import { resetIndustryFilter, loadIndustries, toggleExpandHeadIndustry, selectIndustry, unselectIndustry, filterIndustries } from 'src/app/root-store/jobseeker-store/industry-picker/actions';
import { selectDisplayHeadIndustriesSorted, selectHeadIndustriesExpandedMap, selectIndustriesSelectedMap, selectDisplaySelectedIndustriesTags, selectMaxIndustriesReached } from 'src/app/root-store/jobseeker-store/industry-picker/selectors';
import { selectIndustriesMap } from 'src/app/root-store/jobseeker-store/jobseeker-profile/selectors';

@Component({
    selector: 'app-industry-picker',
    templateUrl: './industry-picker.component.html',
    styleUrls: ['./industry-picker.component.scss'],
    standalone: false
})
export class IndustryPickerComponent implements OnInit {
  navigationSubs: Subscription;

  public displayHeadIndustries$: Observable<IndustryListItem[]>;
  public headIndustriesExpandedMap$: Observable<Dictionary<boolean>>;
  public industriesSelectedMap$: Observable<Dictionary<boolean>>;
  public allIndustriesMap$: Observable<Dictionary<IndustryListItem>>;
  public selectedIndustriesDisplayTags$: Observable<IndustryListItem[]>;
  public maxIndustriesReached$: Observable<boolean>;
  public systemConfigs$: Observable<SystemConfig>;

  public buttonType: any;
  public buttonAttributeType: any;
  
  constructor(public dialogRef: MatDialogRef<IndustryPickerComponent>, @Inject(MAT_DIALOG_DATA) public industryData: any, private store: Store<AppState>, private router: Router) {
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;

    this.navigationSubs = this.router.events.subscribe(e => {
      if(e instanceof NavigationEnd){
        this.dialogRef.close();
      }
    });
  }
  ngOnInit(): void {
    this.displayHeadIndustries$ = this.store.pipe(select(selectDisplayHeadIndustriesSorted));
    this.headIndustriesExpandedMap$ = this.store.pipe(select(selectHeadIndustriesExpandedMap));
    this.industriesSelectedMap$ = this.store.pipe(select(selectIndustriesSelectedMap));
    this.allIndustriesMap$ = this.store.pipe(select(selectIndustriesMap));
    this.selectedIndustriesDisplayTags$ = this.store.pipe(select(selectDisplaySelectedIndustriesTags));
    this.maxIndustriesReached$ = this.store.pipe(select(selectMaxIndustriesReached));
    this.systemConfigs$ = this.store.pipe(select(selectSystemConfigs));

    setTimeout(() => {
      this.store.dispatch(resetIndustryFilter());
      this.store.dispatch(loadIndustries({ payload: { industryIds: this.industryData.industryIds }}));
    }, 0);
  }

  public onToggleExpandHeadIndustry(head: IndustryListItem){
    this.store.dispatch(toggleExpandHeadIndustry({ payload: { industryId: head.id }}));
  }

  onToggleIndustry(industryId: string, event: MatCheckboxChange){
    if(event.checked){
      this.store.dispatch(selectIndustry({ payload: { industryId: industryId }}));
    }
    else {
      this.store.dispatch(unselectIndustry({ payload: { industryId: industryId }}));
    }
  }

  onRemoveIndustry(industryId: string){
    this.store.dispatch(unselectIndustry({ payload: { industryId: industryId }}));
  }

  onSearch(query){
    this.store.dispatch(filterIndustries({ payload: { query: query.target.value }}));
  }

  onSave(industries: IndustryListItem[]){
    const industryIds = industries.map(c => c.id);
    this.dialogRef.close(industryIds);
  }
  
  onCancel(){
    this.dialogRef.close(null);
  }

  ngOnDestroy() {
    this.navigationSubs.unsubscribe();
  }
}
